import { createReducer, on } from '@ngrx/store';
import RoleInterimActions from '../../actions/generations/role.actions';
import { GenerationActions } from '../../actions/generations/generation.actions';

interface RoleState {
  roles: any[];
}
const initialState: RoleState = {
  roles: []
};

const RoleInterimReducer = createReducer(
  initialState,
  /**
   * Sets the roles in the state with the provided roles array.
   */
  on(RoleInterimActions.setRoles, (state, { roles }) => {
    console.log('roles interim set role reducer called', { rolesCount: roles?.length || 0 });

    return {
      ...state,
      roles: Array.isArray(roles) ? [...roles] : []
    };
  }),
  /**
   * Handles updating existing roles.
   * If the role already exists (matched by id), it updates the role with new data.
   */
  on(RoleInterimActions.updateRoleSuccess, (state, { role }) => {
    const updatedRoles = state.roles.map((r) => {
      if (r.sid === role.sid) {
        return { ...r, ...role };
      }
      return r;
    });

    return {
      ...state,
      roles: [...updatedRoles]
    };
  }),
  /**
   * Adds a new role to the state.
   */
  on(RoleInterimActions.createRoleSuccess, (state, { role }) => {
    return {
      ...state,
      roles: [role, ...state.roles]
    };
  }),
  /**
   * Deletes a role from the state based on the provided roleId.
   */
  on(RoleInterimActions.deleteRoleSuccess, (state, { roleId }) => {
    const filteredRoles = state.roles.filter((role) => role.sid !== roleId);
    return {
      ...state,
      roles: filteredRoles
    };
  }),
  /**
   * Resets the state to its initial values when a generation reset action is dispatched.
   */
  on(GenerationActions.resetGeneration, (state) => ({
    ...initialState
  })),
  on(RoleInterimActions.clearRolesState, (state) => ({
    ...initialState
  }))
);

export { RoleInterimReducer, RoleState };
